/* RCD: level-1 nav parents toggle their dropdown instead of navigating. */
(function () {
  document.documentElement.classList.add('rcd-nav-js');
  function menuEl() { return document.querySelector('.header__menu'); }
  function isDesktopNav() {
    var n = menuEl();
    return !!n && getComputedStyle(n).display !== 'none';
  }
  function topParents() {
    var all = document.querySelectorAll('.header__menu .header__menu-item--parent');
    return Array.prototype.filter.call(all, function (li) {
      var a = li.querySelector(':scope > a.header__menu-item-link');
      return !!a && a.classList.contains('link-level-1');
    });
  }
  function shut(li) {
    li.removeAttribute('data-rcd-open');
    var a = li.querySelector(':scope > a.header__menu-item-link');
    if (a) a.setAttribute('aria-expanded', 'false');
  }
  function shutAll(except) {
    topParents().forEach(function (li) { if (li !== except) shut(li); });
  }
  document.addEventListener('click', function (e) {
    if (!isDesktopNav()) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var link = t.closest('a.header__menu-item-link.link-level-1');
    if (!link) { shutAll(null); return; }
    var li = link.parentElement;
    if (!li || !li.classList.contains('header__menu-item--parent')) return;
    e.preventDefault();
    var wasOpen = li.getAttribute('data-rcd-open') === 'true';
    shutAll(li);
    if (wasOpen) {
      shut(li);
    } else {
      li.setAttribute('data-rcd-open', 'true');
      link.setAttribute('aria-expanded', 'true');
    }
  }, false);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) shutAll(null);
  });
})();
